import { render, staticRenderFns } from "./UpdateCategory.vue?vue&type=template&id=70b47f5a"
import script from "./UpdateCategory.vue?vue&type=script&lang=js"
export * from "./UpdateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports